import { css } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';
import { NavLink } from 'react-router';

import {
	ResyncAccounts,
	SalesforceImport,
} from '@adflow/frontend/feat-salesforce-import';
import { AdflowLogo } from '@adflow/frontend/ui-assets';
import { APP_HEADER_HEIGHT } from '@adflow/frontend/ui-layout';
import { theme } from '@adflow/frontend/ui-theme';

import { GearMenu } from './GearMenu';
import { HeaderItems } from './HeaderItems';
import { UserMenu } from './UserMenu';

const styles = {
	header: css({
		backgroundColor: theme.colors.background.paper,
		display: 'flex',
		height: APP_HEADER_HEIGHT,
		borderBottom: '1px solid #d1fcbc',
		color: theme.colors.palettes.primary.dark,
	}),
	headerLogoContainer: css({
		paddingLeft: '1rem',
		paddingRight: '1rem',
		paddingTop: '0.5rem',
		paddingBottom: '0.5rem',
	}),
	headerRight: css({
		display: 'flex',
		alignItems: 'stretch',
	}),
	iconButton: css(
		// Give the user a big area to tap/click even if the button's icon is small.
		{
			paddingLeft: '0.75rem',
			paddingRight: '0.75rem',

			// Center the icon vertically and horizontally.
			display: 'flex',
			alignItems: 'center',
		}
	),
};

export interface HeaderProps {
	outerStyle?: CSSInterpolation;
}

export function Header(props: HeaderProps) {
	return (
		<header css={[styles.header, props.outerStyle]}>
			<NavLink to="/" end css={styles.headerLogoContainer}>
				<AdflowLogo height="42" width="42" title="AdFlow" />
			</NavLink>
			<HeaderItems iconButtonStyle={styles.iconButton} />
			<div css={styles.headerRight}>
				<SalesforceImport />
				<ResyncAccounts />
				<GearMenu iconButtonStyle={styles.iconButton} />
				<UserMenu />
			</div>
		</header>
	);
}
